import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { CurrencyStateModel } from 'models/setting/currency/currency.model';
import { v4 as uuidv4 } from 'uuid';
import {
  activeCurrencyAction,
  createCurrencyAction,
  deleteCurrencyAction,
  getCurrencyAction,
  inactiveCurrencyAction,
  listCurrencyAction,
  updateCurrencyAction,
} from './currency.action';

const initialState: CurrencyStateModel = {
  currencyListData: null,
  currencyDetail: null,

  triggerSaveCurrency: null,

  loadingList: false,
  loadingDetail: false,
};

export const currencySlice = createSlice({
  name: 'currency',
  initialState,
  reducers: {
    setCurrencyStateAction: (
      state,
      action: PayloadAction<Partial<CurrencyStateModel>>,
    ) =>
      ({
        ...state,
        ...action?.payload,
      } as CurrencyStateModel),
    resetCurrencyStateAction: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCurrencyAction.pending, (state) => ({
        ...state,
        currencyDetail: null,
        loadingDetail: true,
      }))
      .addCase(getCurrencyAction.fulfilled, (state, { payload }) => ({
        ...state,
        currencyDetail: payload?.data || null,
        loadingDetail: false,
      }))
      .addCase(getCurrencyAction.rejected, (state) => ({
        ...state,
        currencyDetail: null,
        loadingDetail: false,
      }))
      .addCase(listCurrencyAction.pending, (state) => ({
        ...state,
        loadingList: true,
      }))
      .addCase(listCurrencyAction.fulfilled, (state, { payload }) => ({
        ...state,
        loadingList: false,
        currencyListData: {
          items: payload?.data?.items || [],
          totalItems: payload?.data?.totalItems || 0,
          totalPages: payload?.data?.totalPages || 0,
        },
      }))
      .addCase(listCurrencyAction.rejected, (state) => ({
        ...state,
        loadingList: false,
      }))
      .addCase(createCurrencyAction.fulfilled, (state) => ({
        ...state,
        triggerSaveCurrency: { id: uuidv4() },
      }))
      .addCase(updateCurrencyAction.fulfilled, (state) => ({
        ...state,
        triggerSaveCurrency: { id: uuidv4() },
      }))

      .addCase(deleteCurrencyAction.pending, (state) => ({
        ...state,
        loadingList: true,
      }))
      .addCase(deleteCurrencyAction.fulfilled, (state) => ({
        ...state,
        triggerSaveCurrency: { id: uuidv4() },
      }))
      .addCase(deleteCurrencyAction.rejected, (state) => ({
        ...state,
        loadingList: false,
      }))
      .addCase(activeCurrencyAction.fulfilled, (state) => ({
        ...state,
        triggerSaveCurrency: { id: uuidv4() },
        loadingList: false,
      }))
      .addCase(inactiveCurrencyAction.fulfilled, (state) => ({
        ...state,
        triggerSaveCurrency: { id: uuidv4() },
        loadingList: false,
      }));
  },
});

export const { setCurrencyStateAction, resetCurrencyStateAction } =
  currencySlice.actions;

export default currencySlice.reducer;
